export default "__VITE_ASSET__DRq6qT9G__"